import { IRelatorioFiltro } from './relatorio-filtro.interface';

export class RelatorioFiltros<T> {

  private filtros: IRelatorioFiltro[];

  constructor() {
    this.filtros = [];
  }

  add(filtro: IRelatorioFiltro) {
    if ( !filtro.valorDeExibicao ) {
      filtro.valorDeExibicao = filtro.valor;
    }
    this.filtros.push(filtro);
  }

  getFiltros(): IRelatorioFiltro[] {
    return this.filtros;
  }

  parseToDefaultFilter(): T {
    const defaultFilter = {} as T;
    for ( const filtro of this.filtros ) {
      defaultFilter[filtro.field] = filtro.valor;
    }

    return defaultFilter;
  }

}